export default function InscrieriPregatitoarePage() {

  const documente = [
    { titlu: "Ghid pentru părinți", fisier: "/educatie/inscrieriPregatitoare/Ghid pentru părinți.pdf"},
    { titlu: "Metodologie de înscriere", fisier: "/educatie/inscrieriPregatitoare/OME_4019_2024-1-25-Metodologie_cadru.pdf" },
    { titlu: "Calendarul înscrierii în învățământ", fisier: "/educatie/inscrieriPregatitoare/OMEC 3334.pdf" },
    { titlu: "Stuctura anului școlar 2026-2027", fisier: "/educatie/inscrieriPregatitoare/Ordin-Nr.-3.1942026-STRUCTURA-AN-SCOLAR-2026-2027-Monitorul-Oficial-Partea-I-nr.-126.pdf" },
    { titlu: "Informatii clasa pregatitoare", fisier: "/educatie/inscrieriPregatitoare/Informații clasa pregătitoare 2026-2027.pdf"}
 
  ];

  return (
    <div className="bg-gray-50 min-h-screen">
      <main className="max-w-7xl mx-auto px-4 py-8">

        <div className="mb-12">
          <h2 className="text-3xl font-bold mb-6">
            Înscrierea în clasa pregătitoare 2026-2027
          </h2>

          <ul className="space-y-3">
            {documente.map((doc, index) => (
              <li key={index}>
                <a
                  href={doc.fisier}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  {doc.titlu}
                </a>
              </li>
            ))}
          </ul>

        </div>

      </main>
    </div>
  );
}